import type { ReactNode } from "react";

/** Her ekranın başlığı (ui.md §12.4): h1, tek cümle açıklama, isteğe bağlı meta satırı ve sağda eylemler. */
export function PageHeader({ title, description, meta, actions }: { title: ReactNode; description?: string; meta?: ReactNode; actions?: ReactNode }) {
  return (
    <div data-slot="page-header" className="flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
        {meta && <div className="mt-2 flex flex-wrap items-center gap-2 text-sm text-muted-foreground">{meta}</div>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
